import type { PersonChooserProps } from '@/shared/custom-fields'

import { UserChooser } from '../users/UserChooser'

/** Site Management's user chooser as GW-29's person chooser, for every person field. */
export function UserPersonChooser(props: PersonChooserProps) {
  return <UserChooser open={props.open} title={props.title} selectedId={props.selected} onClose={props.onClose} onChoose={props.onChoose} />
}
